import React from 'react';
import { ProgressPage } from '../ProgressPage';

export function ProgressTrackingPage() {
  return <ProgressPage />;
}